module.exports = __webpack_public_path__ + "static/media/163.4e96de0c.jpg";